import { render, staticRenderFns } from "./LoginMicrosoft.vue?vue&type=template&id=9e0831a2&"
import script from "./LoginMicrosoft.vue?vue&type=script&lang=js&"
export * from "./LoginMicrosoft.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports